import {useEffect, useState} from 'react';

/** Debounce window-resize remounts so a drag-resize doesn't thrash re-inits. */
const RESIZE_DEBOUNCE_MS = 150;

/**
 * `react-cropper`'s responsive mode rescales using only the container's width
 * ratio, compounding distortion on each resize. Instead, callers disable
 * `responsive` on the `Cropper` instance and key it with the value returned
 * here, forcing a debounced full remount that re-initializes cleanly from the
 * image's natural dimensions on each qualifying resize.
 */
export const useCropperRemountOnResize = (debounceMs: number = RESIZE_DEBOUNCE_MS): number => {
  const [instanceKey, setInstanceKey] = useState(0);

  useEffect(() => {
    let resizeTimeout: ReturnType<typeof setTimeout> | undefined;
    const handleResize = () => {
      if (resizeTimeout !== undefined) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(() => {
        setInstanceKey((key) => key + 1);
      }, debounceMs);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      if (resizeTimeout !== undefined) {
        clearTimeout(resizeTimeout);
      }
      window.removeEventListener('resize', handleResize);
    };
  }, [debounceMs]);

  return instanceKey;
};


